"use client";
import React, { useState, useEffect } from "react";

const ScrollToTopButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight / 2) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      title={"Scroll To Top"}
      className="scroll-to-top-btn"
      onClick={scrollToTop}
      style={{
        display: isVisible ? "block" : "none",
      }}
    >
      ↑
    </button>
  );
};

export default ScrollToTopButton;
